import { render, staticRenderFns } from "./PageNodeChildren.vue?vue&type=template&id=4caf28cf"
import script from "./PageNodeChildren.vue?vue&type=script&lang=js"
export * from "./PageNodeChildren.vue?vue&type=script&lang=js"
import style0 from "./PageNodeChildren.vue?vue&type=style&index=0&id=4caf28cf&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports